module.exports = __webpack_public_path__ + "static/img/bgphone-top-p20n.2f51d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bgphone-top-p20n.jpg
// module id = RKjl
// module chunks = 1